import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import Select from "react-select"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { Field, Formik, Form, ErrorMessage } from "formik"
import { showAlert } from "store/reducers/alertReducer"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import {
  addLoyaltyPoints,
  getAllCustomersList,
} from "store/actions/customersAction"
import { DatePicker } from "rsuite"
import { useNavigate } from "react-router-dom"
import { addLoyaltyPointSchema } from "components/Common/validation"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import { disablePastDates } from "components/Common/constants"
import TextError from "components/Shared/TextError"

const initialValues = {
  remarks: "",
  points: "",
  expiresAt: "",
  customers: [],
}
const AddLoyaltyPoints = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Add Loyalty Points | Sign Burger")

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { customersDropdownList, isLoading } = useSelector(
    state => state.Customers
  )

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      7,
      "customersPermission_2",
      accountType
    )

    if (!isPermissionEdit) {
      navigate("/dashboard")
    }
  }, [])

  const [formValues, setFormValues] = useState(initialValues)
  const [customerOptions, setCustomerOptions] = useState([])

  useEffect(() => {
    if (customersDropdownList.length > 0) {
      const updatedCustomerOption = customersDropdownList?.map(item => ({
        label: `${item.firstName} ${item.lastName}, ${
          item?.phoneNumber ? item?.phoneNumber : ""
        }`,
        value: item._id,
      }))
      setCustomerOptions(updatedCustomerOption)
    }
  }, [customersDropdownList])

  const fetchCustomersList = keyword => {
    const payload = {
      keyword,
    }
    dispatch(getAllCustomersList(payload))
  }

  const handleOnSubmit = values => {
    const { remarks, points, expiresAt, customers } = values
    const updatedCustomers = customers?.map(item => item.value)

    const payload = {
      remarks,
      points,
      expiresAt,
      customers: updatedCustomers,
    }

    dispatch(addLoyaltyPoints(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          navigate(`/customers/loyalty`)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <div className="page-content add_roles_page">
      <Breadcrumbs />
      <Row>
        <Col xl={12}>
          <Card>
            <CardBody>
              <CardTitle className="mb-2 d-flex align-items-center">
                <BackButton /> {t("Add Loyalty Points")}
              </CardTitle>
              <Formik
                initialValues={formValues}
                enableReinitialize={true}
                validationSchema={addLoyaltyPointSchema("GLOBAL")}
                onSubmit={handleOnSubmit}
              >
                {({ values, setFieldValue, errors, touched }) => (
                  <Form>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="points">
                            <span className="text-danger">*</span> {t("Points")}
                          </label>
                          <Field
                            type="number"
                            id="points"
                            name="points"
                            placeholder={t("Points")}
                            className={`form-control ${
                              touched.points && errors.points
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="points" />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mt-2">
                          <label htmlFor="points">
                            <span className="text-danger">*</span>{" "}
                            {t("Please Type To Search Customer")}
                          </label>
                          <Select
                            value={values.customers}
                            isMulti={true}
                            onChange={selectedValue => {
                              setFieldValue("customers", selectedValue)
                            }}
                            options={customerOptions?.map(item => ({
                              label: item.label,
                              value: item.value,
                            }))}
                            onInputChange={value => fetchCustomersList(value)}
                            placeholder={t("Please Type To Search Customer")}
                            className={`select2-selection ${
                              touched.customers && errors.customers
                                ? "danger_color_border"
                                : ""
                            } `}
                          />
                          <TextError name="customers" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form_field full_rs_picker">
                          <label htmlFor="expiresAt">{t("Expires At")}</label>
                          <DatePicker
                            showTime={{ format: "HH:mm" }} // Show time picker
                            format="yyyy-MM-dd HH:mm"
                            onChange={value => {
                              setFieldValue("expiresAt", value)
                            }}
                            value={values.expiresAt}
                            placeholder="2024-07-16 14:30"
                            disabledDate={disablePastDates}
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="name">
                            <span className="text-danger">*</span> {t("Remark")}
                          </label>
                          <Field
                            as="textarea"
                            id="remarks"
                            name="remarks"
                            placeholder={t("Remark")}
                            className={`form-control ${
                              touched.remarks && errors.remarks
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="remarks" />
                        </div>
                      </div>

                      <div className="mt-2"></div>
                      <div className="col-12 d-flex justify-content-end my-5">
                        <Button
                          type="button"
                          className="mx-2"
                          color="secondary"
                          onClick={() => navigate(-1)}
                        >
                          {t("Cancel")}
                        </Button>
                        <Button
                          type="submit"
                          color="success"
                          disabled={isLoading}
                          className="w_fit_content"
                        >
                          {t("Add")}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AddLoyaltyPoints
